var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-manage"},[(_vm.role == 'purchase')?_c('InfoManagePurchaser'):_vm._e(),(_vm.role == 'supplier')?_c('InfoManageSupplier'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }